export default class FacilityName {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./src/models/facilities/facility-name.ts